import './Training.css';
import Trainingslist from './Trainingslist';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { getTrainings } from '../../actions/trainings';
import { getAllFlashcardHeaders } from '../../actions/flashcards';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import Trainingform from './Trainingform';
import Testform from './Testform';

const TRAIN_ALL_MAX_FLASHCARDS_OPTIONS = [10, 20, 30, 50, 75, 100];
const TRAIN_ALL_MAX_FLASHCARDS_ALL = 'all';
const DEFAULT_TRAIN_ALL_MAX_FLASHCARDS = 30;

function Training() {
  const trainings = useSelector((state) => state.trainings);
  const [open, setOpen] = useState(false);
  const [opentest, setOpenTest] = useState(false);
  const [training, setTraining] = useState('');
  const [currentId, setCurrentId] = useState(0);
  const [trainAllMaxFlashcards, setTrainAllMaxFlashcards] = useState(
    DEFAULT_TRAIN_ALL_MAX_FLASHCARDS,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTrainings());
    dispatch(getAllFlashcardHeaders());
  }, [currentId, dispatch]);

  const handleClickCreate = () => {
    setCurrentId(0);
    setOpen(true);
  };

  const handleClickOpen = (e, training) => {
    setTraining(training);
    setOpenTest(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  const handleClickCloseTest = () => {
    setOpenTest(false);
  };

  const handleClickEdit = (currentId) => {
    setCurrentId(currentId);
    setOpen(true);
  };

  let form;
  if (open) {
    form = (
      <Trainingform
        training={trainings.filter((training) => training._id === currentId)[0]}
        currentId={currentId}
        close={handleClickClose}
      />
    );
  }

  let testform;
  if (opentest) {
    testform = (
      <Testform
        key={training === '' ? '__all__' : training}
        close={handleClickCloseTest}
        training={training}
        maxFlashcardsPerTrainingSession={trainAllMaxFlashcards}
      />
    );
  }

  return (
    <div>
      <h2> Training sessions:</h2>
      {form}
      {testform}
      <Trainingslist
        trainings={trainings}
        setCurrentId={handleClickEdit}
        handleClickOpen={handleClickOpen}
      />
      <br />
      <IconButton onClick={handleClickCreate} aria-label="delete">
        <AddCircleIcon />
      </IconButton>
      create training
      <FormControl variant="outlined" margin="dense" style={{ minWidth: 90, marginLeft: 12  }}>
        <InputLabel id="train-all-max-cards-label">Max. cards</InputLabel>
        <Select
          labelId="train-all-max-cards-label"
          id="train-all-max-cards"
          value={trainAllMaxFlashcards}
          onChange={(e) => setTrainAllMaxFlashcards(e.target.value)}
          label="Max. cards"
        >
          <MenuItem value={TRAIN_ALL_MAX_FLASHCARDS_ALL}>all</MenuItem>
          {TRAIN_ALL_MAX_FLASHCARDS_OPTIONS.map((n) => (
            <MenuItem key={n} value={n}>
              {n}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <IconButton
        onClick={(e) => {
          handleClickOpen(e, '');
        }}
        aria-label="start train all session"
      >
        <DirectionsRunIcon />
      </IconButton>
      train all
    </div>
  );
}

export default Training;
